import * as types from "./actionTypes";

const initialState = {
  keywords: [
    "developer",
    "engineer",
    "programmer",
    "architect",
    "designer",
    "consultant",
    "administrator",
    "coach",
    "lead",
    "manager",
    "master",
    "specialist",
    "modeler",
    "director",
    "hacker",
  ],
  activeCandidates: [],
  candidateDetails: {},
  candidateDetailLoading: false,
  interested_jobs_daycount: 0,
  candidateInterestedJobsLoading: false,
  jobs_daycount: 0,
  candidateJobs: [],
  candidateJobsCount: 0,
  candidateJobsLoading: false,
  jobDetails: {},
  jobDetailsLoading: false,
  candidateSubmissions: [],
  tabView: "",
  selectedSubmission: {},
  openRightPanel: false,
  updateSubmissions: [],
  sendJobToCandidate: [],
  sendProfileToVendor: [],
  rateConfirmation: [],
  interviewSchedule: [],
  updateInterview: [],
  candidateDocuments: [],
  createNotification: {},
  candidateInterestedJobs: [],
  alertMessage: "",
  alertStatus: "",
  searchCompanyName: "",
  searchLocation: "",
  searchJobType: "",
  searchTitle: "",
  searchExperience: "",
  suggestions: [],
  candidateResumesList: [],
  submissionSelectedResume: {},
  refreshKey: null, // Add refreshKey to state
  submissionStatus: {
    bench_status_id: null,
    status_value: null,
    candidate_id: null,
    job_id: null,
    loading: false,
    error: null,
    lastUpdated: null,
  },
  loadingViewedStatus: false,
  viewedStatusData: null,
  viewedStatusError: null,
  activeCandidatesLoading: false,
  hasAttemptedLoad: false, // Track if we've attempted to load candidates
  activeCandidateTab: "jobstab",
};

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.USER_LOGOUT:
      return initialState;

    case types.ALERT_SNACK_BAR_ACTION:
      return {
        ...state,
        alertMessage: action.alertMessage,
        alertStatus: action.alertStatus,
        openAlert: true,
      };

    case types.CLOSE_SNACK_BAR_ACTION:
      return {
        ...state,
        openAlert: false,
      };

    case types.RESET_ACTION:
    case types.MY_CANDIDATES_RESET_ACTION:
      return {
        ...state,
        candidateJobs: [],
        candidateInterestedJobs: [],
        candidateJobsCount: 0,
        jobDetails: {},
        jobDetailsLoading: true,
        candidateSubmissions: [],
        selectedSubmission: null,
        submissionStatus: {
          loading: false,
          status_value: null,
          bench_status_id: null,
        },
        tabView: "Jobs",
        activeCandidateTab: 0,
        candidateInterestedJobsLoading: false,
      };

    case types.GET_ACTIVE_CANDIDATES_ACTION_REQUEST:
      return {
        ...state,
        activeCandidatesLoading: true,
        hasAttemptedLoad: true, // Mark that we've attempted to load
      };

    case types.GET_ACTIVE_CANDIDATES_ACTION:
      return {
        ...state,
        activeCandidates:
          parseInt(action.pageNo) === 1
            ? [...action.payload]
            : [...state.activeCandidates, ...action.payload],
        total_candidates: action.total_candidates,
        activeCandidatesLoading: false,
        hasAttemptedLoad: true,
        loading: true,
      };

    case types.GET_ACTIVE_CANDIDATES_ACTION_FAIL:
      return {
        ...state,
        activeCandidatesLoading: false,
        hasAttemptedLoad: true,
      };

    case types.CLEAR_CANDIDATE_DETAILS_ACTION:
      return {
        ...state,
        candidateDetails: {},
        candidateDetailLoading: false,
        interested_jobs_daycount: 0,
        jobs_daycount: 0,
        candidateJobs: [],
        candidateInterestedJobs: [],
        candidateJobsCount: 0,
        candidateSubmissions: [],
        selectedSubmission: null,
        submissionStatus: {
          loading: false,
          status_value: null,
          bench_status_id: null,
        },
        jobDetails: {},
        jobDetailsLoading: false,
        candidateInterestedJobsLoading: false,
      };

    case types.GET_CANDIDATE_DETAIL_LOADING_ACTION:
      return {
        ...state,
        candidateDetailLoading: true,
        candidateJobsLoading: true,
        candidateJobs: [],
        candidateJobsCount: 0,
        candidateInterestedJobs: [],
        candidateInterestedJobsLoading: true,
        candidateSubmissions: [],
        selectedSubmission: null,
        submissionStatus: {
          loading: false,
          status_value: null,
          bench_status_id: null,
        },
        jobDetails: {},
        jobDetailsLoading: true,
      };

    case types.GET_CANDIDATE_DETAIL_ACTION:
      return {
        ...state,
        candidateDetails: action.payload,
        candidateDetailLoading: false,
        candidateJobsLoading: true,
        interested_jobs_daycount: action.interested_jobs_daycount,
        jobs_daycount: action.jobs_daycount,
        searchCompanyName: "",
        searchLocation: "",
        searchJobType: "",
        searchTitle: "",
        searchExperience: "",
        suggestions: [],
        activeCandidates: state.activeCandidates.map((candidate) =>
          candidate.candidate_id === action.payload.candidate_id
            ? { ...candidate, ...action.payload }
            : candidate
        ),
        refreshKey: Date.now(),
      };

    case types.GET_CANDIDATE_DETAIL_ACTION_FAIL:
      return {
        ...state,
        candidateDetailLoading: false,
        candidateJobsLoading: false,
        jobDetailsLoading: false,
      };

    case types.GET_SOLR_JOBS_ACTION_REQUEST:
      return {
        ...state,
        candidateJobsLoading: true,
      };

    case types.GET_SOLR_JOBS_ACTION:
      return {
        ...state,
        candidateJobs: [...action.payload?.solrJobs],
        candidateJobsCount: action.payload?.solrJobsCount,
        candidateJobsLoading: false,
        jobDetailsLoading:
          action.payload?.solrJobs?.length > 0 ? state.jobDetailsLoading : false,
      };

    case types.GET_SOLR_JOBS_ACTION_FAIL:
      return {
        ...state,
        candidateJobsLoading: false,
        jobDetailsLoading: false,
      };

    case types.CLEAR_JOBS_LIST:
      return {
        ...state,
        candidateJobs: [],
        candidateJobsCount: 0,
      };

    case types.GET_SOLR_JOBS_COUNT_ACTION:
      return {
        ...state,
        jobs_daycount: action.payload,
      };

    case types.GET_JOB_DETAILS_ACTION_REQUEST:
      return {
        ...state,
        jobDetailsLoading: true,
        // (optional) clear old details to avoid stale view while loading
        // jobDetails: {},
      };

    case types.GET_JOB_DETAILS_ACTION:
      return {
        ...state,
        jobDetails: action.payload,
        jobDetailsLoading: false,
      };

    case types.GET_JOB_DETAILS_ACTION_FAIL:
      return {
        ...state,
        jobDetailsLoading: false,
      };

    case types.GET_CANDIDATE_SUBMISSIONS_ACTION:
      return {
        ...state,
        candidateSubmissions: action.payload,
      };

    case types.SELECTED_TAB_VIEW_ACTION:
      return {
        ...state,
        tabView: action.payload,
      };

    case types.SELECTED_SUBMISSION_ACTION: {
      const prevId = state.selectedSubmission?.id ?? state.selectedSubmission?.submission_id;
      const nextId = action.payload?.id ?? action.payload?.submission_id;
      const isSameSubmission =
        prevId != null && nextId != null && String(prevId) === String(nextId);
      return {
        ...state,
        selectedSubmission: action.payload,
        // Only close panel when switching submissions — not on in-place updates (e.g. rate edit)
        openRightPanel: isSameSubmission ? state.openRightPanel : false,
      };
    }

    case types.UPDATE_SUBMISSIONS_ACTION:
      return {
        ...state,
        updateSubmissions: action.payload,
      };

    case types.UPDATE_SUBMISSION_STATUS:
      const { submissionId, newStatus } = action.payload;
      const updatedSubmissions = state.candidateSubmissions.map(sub =>
        sub.id === submissionId ? { ...sub, pStatusName: newStatus } : sub
      );
      return {
        ...state,
        candidateSubmissions: updatedSubmissions,
        selectedSubmission: state.selectedSubmission?.id === submissionId
          ? { ...state.selectedSubmission, pStatusName: newStatus }
          : state.selectedSubmission,
      };

    case types.SEND_JOB_TO_CANDIDATE_ACTION:
      return {
        ...state,
        sendJobToCandidate: action.payload,
      };

    case types.SEND_PROFILE_TO_VENDOR:
      return {
        ...state,
        sendProfileToVendor: action.payload,
      };

    case types.RATE_CONFIRMATION_ACTION:
      return {
        ...state,
        rateConfirmation: action.payload,
      };

    case types.INTERVIEW_SCHEDULE_ACTION:
      return {
        ...state,
        interviewSchedule: action.payload,
      };

    case types.UPDATE_INTERVIEW_SCHEDULE_ACTION:
      return {
        ...state,
        updateInterview: action.payload,
      };

    case types.GET_CANDIDATE_DOCUMENTS_ACTION:
      return {
        ...state,
        candidateDocuments: action.payload,
      };

    case types.CREATE_NOTIFICATION_ACTION:
      return {
        ...state,
        createNotification: action.payload,
      };

    case types.OPEN_RIGHT_PANEL_ACTION:
      return {
        ...state,
        openRightPanel: action.payload,
      };

    case types.GET_CANDIDATE_INTERESTED_JOBS_ACTION_REQUEST:
      return {
        ...state,
        candidateInterestedJobsLoading: true,
      };

    case types.GET_CANDIDATE_INTERESTED_JOBS_ACTION:
      return {
        ...state,
        candidateInterestedJobs: action.payload || [],
        candidateInterestedJobsLoading: false,
        jobDetails:
          action.payload?.length > 0 ? state.jobDetails : {},
        jobDetailsLoading:
          action.payload?.length > 0 ? state.jobDetailsLoading : false,
      };

    case types.GET_CANDIDATE_INTERESTED_JOBS_ACTION_FAIL:
      return {
        ...state,
        candidateInterestedJobsLoading: false,
        jobDetailsLoading: false,
      };

    case types.SET_SEARCH_INPUTS:
      return {
        ...state,
        searchCompanyName: action.payload.searchCompanyName,
        searchLocation: action.payload.searchLocation,
        searchJobType: action.payload.searchJobType,
        searchTitle: action.payload.searchTitle,
        searchExperience: action.payload.searchExperience || "",
      };

    case types.GET_SEARCH_SUGGESTIONS_ACTION:
      return {
        ...state,
        suggestions: action.payload,
      };

    case types.GET_CANDIDATES_RESUMES_LIST_ACTION:
      return {
        ...state,
        candidateResumesList: action.payload,
      };

    case types.GET_CANDIDATES_RESUMES_LIST_ACTION_TEMP:
      return {
        ...state,
        candidateResumesList: action.payload,
      };

    case types.SELECTED_RESUME_ACTION:
      return {
        ...state,
        submissionSelectedResume: action.payload,
      };

    case types.GET_SUBMISSION_RESUME_DETAILS_ACTION:
      return {
        ...state,
        submissionSelectedResume: action.payload,
      };
    case types.GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION: {
      const payloadCandId = action.payload?.candidate_id;
      const payloadJobId = action.payload?.job_id;
      const sameSubmissionAsStored =
        payloadCandId != null &&
        payloadJobId != null &&
        Number(payloadCandId) === Number(state.submissionStatus?.candidate_id) &&
        Number(payloadJobId) === Number(state.submissionStatus?.job_id);

      // Preserve previous status only while refetching the SAME submission.
      // Never keep another submission's status (causes left/right step mismatch).
      const nextBenchStatusId =
        action.payload?.bench_status_id != null
          ? action.payload.bench_status_id
          : action.payload?.loading && sameSubmissionAsStored
            ? state.submissionStatus?.bench_status_id ?? null
            : action.payload?.loading
              ? null
              : null;
      const nextStatusValue =
        action.payload?.status_value != null
          ? action.payload.status_value
          : action.payload?.loading && sameSubmissionAsStored
            ? state.submissionStatus?.status_value ?? null
            : null;
      const nextCandidateId =
        payloadCandId ??
        (action.payload?.loading && sameSubmissionAsStored
          ? state.submissionStatus?.candidate_id
          : null);
      const nextJobId =
        payloadJobId ??
        (action.payload?.loading && sameSubmissionAsStored
          ? state.submissionStatus?.job_id
          : null);

      const hasConcreteStatus = action.payload?.bench_status_id != null;
      const matchesSelected =
        hasConcreteStatus &&
        state.selectedSubmission?.candidate_id != null &&
        state.selectedSubmission?.job_id != null &&
        Number(state.selectedSubmission.candidate_id) === Number(payloadCandId) &&
        Number(state.selectedSubmission.job_id) === Number(payloadJobId);

      return {
        ...state,
        submissionStatus: {
          bench_status_id: nextBenchStatusId,
          status_value: nextStatusValue,
          candidate_id: nextCandidateId,
          job_id: nextJobId,
          loading: action.payload?.loading || false,
          error: null,
          lastUpdated: Date.now(),
        },
        candidateSubmissions: hasConcreteStatus
          ? state.candidateSubmissions.map((sub) =>
              Number(sub.candidate_id) === Number(payloadCandId) &&
              Number(sub.job_id) === Number(payloadJobId)
                ? {
                    ...sub,
                    bench_status_id: action.payload.bench_status_id,
                    pStatusName:
                      action.payload?.status_value ?? sub.pStatusName,
                    nStatusName:
                      action.payload?.status_value ?? sub.nStatusName,
                    modified: new Date().toISOString(),
                    ...(action.payload?.s_rate != null &&
                    String(action.payload.s_rate).trim() !== ""
                      ? { s_rate: action.payload.s_rate }
                      : {}),
                  }
                : sub
            )
          : state.candidateSubmissions,
        selectedSubmission: matchesSelected
          ? {
              ...state.selectedSubmission,
              bench_status_id: action.payload.bench_status_id,
              nStatusName:
                action.payload?.status_value ??
                state.selectedSubmission.nStatusName,
              pStatusName:
                action.payload?.status_value ??
                state.selectedSubmission.pStatusName,
              ...(action.payload?.s_rate != null &&
              String(action.payload.s_rate).trim() !== ""
                ? { s_rate: action.payload.s_rate }
                : {}),
            }
          : state.selectedSubmission,
      };
    }
    case types.GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION_FAIL:
      return {
        ...state,
        submissionStatus: {
          ...state.submissionStatus,
          loading: false,
          error: action.payload,
        },
      };
    case types.UPDATE_VIEWED_STATUS_REQUEST:
      return {
        ...state,
        loadingViewedStatus: true,
        viewedStatusError: null,
      }
    case types.UPDATE_VIEWED_STATUS_SUCCESS:
      return {
        ...state,
        loadingViewedStatus: false,
        viewedStatusData: action.payload,
      }
    case types.UPDATE_VIEWED_STATUS_FAIL:
      return {
        ...state,
        loadingViewedStatus: false,
        viewedStatusError: action.error,
      };
    case types.UPDATE_VIEWED_STATUS_LOCAL:
      return {
        ...state,
        candidateSubmissions: state.candidateSubmissions.map((sub) =>
          sub.job_id === action.payload.job_id &&
            sub.candidate_id === action.payload.candidate_id
            ? { ...sub, unread_count: 0 }
            : sub
        ),
      };
    case types.SET_ACTIVE_CANDIDATE_TAB:
      return {
        ...state,
        activeCandidateTab: action.payload,
      }
    default:
      return state;
  }
}
